import { useCallback, useRef } from 'react';

import type { DQLEditorValidityInfo } from './dql-editor-types.js';

/**
 * @internal
 */
export const useValidityInfo = (
  onValidityChange?: (validityInfo: DQLEditorValidityInfo[]) => void,
) => {
  const currentValidityRef = useRef<DQLEditorValidityInfo[]>([]);
  const onValidityChangeRef = useRef<typeof onValidityChange>(undefined);

  onValidityChangeRef.current = onValidityChange;

  return useCallback(
    (validity: DQLEditorValidityInfo[]) => {
      if (
        onValidityChangeRef.current &&
        JSON.stringify(validity) !== JSON.stringify(currentValidityRef.current)
      ) {
        currentValidityRef.current = validity;
        onValidityChangeRef.current(validity);
      }
    },
    // Avoid adding any dependencies to prevent reconfiguring the editor when currentDiagnostics changes
    [],
  );
};
